// extracted by mini-css-extract-plugin
export default {"containerVertical":"styles_containerVertical__yN98F","vertical":"styles_vertical__R0jmu","clickable":"styles_clickable__RSyPR"};